class BlockColumns {
	// Static counter to keep track of the number of BlockColumns instances
	static blockCount = 0;

	constructor(blockEl) {
		this.blockEl = blockEl;
		this.instanceIndex = ++BlockColumns.blockCount; // Increment the blockCount and store the current instance index

		// Ensure the blockEl is a descendant of .block-columns
		if (!this.blockEl.closest('.block-columns')) {
			return;
		}

		this.accordionSections = Array.from(this.blockEl.querySelectorAll('.accordion__section'));

		// Initialize accordion functionality
		if (this.accordionSections.length > 0) {
			this.accordionSections.forEach((section, index) => this.initializeAccordion(section, index));
		}

		// Set up MutationObserver for dynamically added accordion sections
		this.observeMutations();
	}

	initializeAccordion(section, index) {
		const checkbox = section.querySelector('input[type="checkbox"]');
		const label = section.querySelector('.accordion__section-title');
		const content = section.querySelector('.accordion__section-content');

		if (!checkbox || !label || !content) return;

		// Create a unique ID by combining the checkbox name and the instance index
		const uniqueId = `${checkbox.name}-block${this.instanceIndex}-section${index}`;

		// Set initial ARIA attributes based on checkbox state
		this.updateAriaAttributes(checkbox, label, content, uniqueId);

		// Event listener for checkbox state changes
		checkbox.addEventListener('change', () => this.updateAriaAttributes(checkbox, label, content, uniqueId));
	}

	updateAriaAttributes(checkbox, label, content, uniqueId) {
		// Update ARIA attributes
		label.setAttribute('role', 'button');
		label.setAttribute('aria-expanded', checkbox.checked);
		label.setAttribute('aria-controls', uniqueId);

		// Add aria-hidden attribute to the content area
		content.setAttribute('id', uniqueId);
		content.setAttribute('aria-hidden', !checkbox.checked); // Set aria-hidden based on checkbox state
	}

	observeMutations() {
		const observer = new MutationObserver((mutationsList) => {
			// Use Array.from to iterate over the mutation list
			Array.from(mutationsList).forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					// Use Array.from to ensure array-like iteration for addedNodes
					Array.from(mutation.addedNodes).forEach((node) => {
						// Check if the added node is a .accordion__section or contains one
						if (node.nodeType === 1 && (node.matches('.accordion__section') || node.querySelector('.accordion__section'))) {
							const sections = node.matches('.accordion__section')
								? [node]
								: Array.from(node.querySelectorAll('.accordion__section'));

							// Initialize accordion sections dynamically added to the DOM
							sections.forEach((section, index) => this.initializeAccordion(section, index));
						}
					});
				}
			});
		});

		// Observe changes in the current block element
		observer.observe(this.blockEl, {
			childList: true,
			subtree: true
		});
	}
}

export default BlockColumns;
